module.exports = __webpack_public_path__ + "static/media/81.66380fb0.png";